// extracted by mini-css-extract-plugin
export var cardWrapper = "_6n-0";